import type { FC } from 'react';
import type { BlinkTraffic } from '../blinkTraffic';
import { isBumpPlus, isIncreasedTraffic, isLittleTraffic, isNoData } from '../blinkTraffic';
import type { DeviceType } from './App';
import { Rocket } from './Rocket';

interface Props {
    blinkTraffic?: BlinkTraffic | undefined;
    deviceType: DeviceType;
}

export const BlinkPanel: FC<Props> = ({ blinkTraffic }) => {
    if (!blinkTraffic || isNoData(blinkTraffic) || isBumpPlus(blinkTraffic)) {
        return null;
    }

    if (isIncreasedTraffic(blinkTraffic)) {
        return (
            <div className="flex flex-col p-16">
                <div className="flex items-start space-x-16">
                    <div className="pt-6">
                        <Rocket className="flex shrink-0" style={{ width: '40px', height: '40px', minWidth: '40px' }} />
                    </div>
                    <div className="flex min-w-0 flex-col">
                        <p>Denne annonsen har fått ekstra effekt fra {blinkTraffic.productName}</p>
                        <div className="sm:flex sm:flex-row sm:space-x-4">
                            <p className="mb-8">
                                <strong>+{blinkTraffic.increasedTraffic}%</strong> flere klikk enn vanlig
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    if (isLittleTraffic(blinkTraffic)) {
        return (
            <div className="flex flex-col p-16">
                <div className="flex items-start space-x-16 sm:items-center">
                    <div className="pt-6">
                        <Rocket className="flex shrink-0" style={{ width: '40px', height: '40px', minWidth: '40px' }} />
                    </div>
                    <div className="max-w-1/2 flex min-w-0 flex-col">
                        <p>Denne annonsen har fått ekstra effekt fra {blinkTraffic.productName}</p>
                    </div>
                </div>
            </div>
        );
    }

    return null;
};
